import React from 'react';
import logo from '../assets/logo.png';
import './PageLoading.css';

export default function PageLoading({ label = 'Loading Snows ProAm' }) {
  return <main className="site-page-loading" role="status" aria-label={label} aria-busy="true">
    <img src={logo} alt="" width="44" height="44" />
  </main>;
}
